export default "__VITE_ASSET__QJHaCPSa__"